<template>
  <!-- 店铺商品 -->
  <div class="shop-Product">
    <div class="ButtonArea">
      <!-- 服务管理/需求管理 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in ToggleArr"
          :key="index"
          :class="Toggle == item.id ? 'select-p' : ''"
          @click="Toggle = item.id"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 操作按钮 -->
      <div class="button-box">
        <p class="firm-clickable" v-if="Toggle == '1'" @click="handelPublishService">发布服务</p>
        <p class="firm-clickable" v-else @click="handelPublishRequirement">发布需求</p>
        <p>批量上架</p>
        <p>批量下架</p>
        <p>批量删除</p>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="screen">
      <p>状态：</p>
      <!-- 支付类型 下拉选择框 -->
      <div class="size-search">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <p class="user-Id">创建时间：</p>
      <!-- 时间选择input -->
      <el-date-picker
        v-model="value1"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
        clearable
        @clear="value1 = null"
      >
        <!-- HH:mm:ss -->
      </el-date-picker>

      <!-- 搜索重置按钮 -->
      <p class="ser-btn public-style">搜 索</p>
      <p class="heavy-btn public-style">重 置</p>
    </div>
    <!-- 内容 -->
    <div class="content-box">
      <ServiceItem :listArr="listArr" :distinguish="1" v-if="Toggle == '1'"></ServiceItem>
      <Requirement :listArr="listArr1" :distinguish="1" v-else></Requirement>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
  </div>
</template>
 
<script>
import ServiceItem from "./components/ServiceItem.vue"; // 服务项目展示
import Requirement from "./components/Requirement.vue"; // 需求项目展示
import paging from "../../../../../components/paging.vue"; // 分页
export default {
  data() {
    return {
      ToggleArr: [
        {
          name: "服务管理",
          id: "1",
        },
        {
          name: "需求管理",
          id: "2",
        },
      ], // 服务管理 / 需求管理
      Toggle: "1", // 服务管理/需求管理选择
      value: "", // 状态选择
      value1: null, //时间选择（daterange 需用 null）
      options: [], //状态选项
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      listArr: [
        {
          status: "0", // 状态 0已上架  1审核  2审核失败 3已下架
          choose: false,
        },
        { status: "0", choose: false },
        { status: "0", choose: false },
        { status: "1", choose: false },
        { status: "2", choose: false },
        { status: "3", choose: false },
        { status: "2", choose: false },
        { status: "0", choose: false },
      ], //服务项目数据
      listArr1: [
        {
          status: "0", // 状态 0招标  1进行中  2审核  3审核失败 4已下架  5已完成
          choose: false,
        },
        { status: "1", choose: false },
        { status: "2", choose: false },
        { status: "3", choose: false },
        { status: "4", choose: false },
        { status: "5", choose: false },
        { status: "1", choose: false },
        { status: "0", choose: false },
      ], //需求数据
    };
  },
  watch: {},
  components: {
    paging, //分页
    ServiceItem, //服务项目
    Requirement, //需求项目
  },
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.Toggle = this.$route.query.key;
      this.$router.push({ query: {} })
    }
  },
  destroyed() {
    sessionStorage.removeItem("DisplayPage");
  },
  methods: {
    // 发布服务
    handelPublishService() {
      // this.$emit("handelPublishService");
      this.$router.push({
        path: "/HelpShop/publishService",
      });
    },
    // 发布需求
    handelPublishRequirement() {
      this.$router.push({
        path: "/HelpShop/publishRequires",
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
// 时间选择框样式（保留左右内边距，避免清空叉号被挤掉/点不中）
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}
//
.shop-Product {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
  // 按钮区
  .ButtonArea {
    width: 100%;
    height: 35px;
    display: flex;
    // 服务管理/需求管理
    .Toggle {
      width: 250px;
      display: flex;
      p {
        width: 110px;
        height: 33px;
        line-height: 33px;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        margin-right: 10px;
        cursor: pointer;
      }
      .select-p {
        height: 33px;
        line-height: 33px;
        border: 1px solid #409eff ;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        color: #409eff ;
      }
    }
    // 操作按钮
    .button-box {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      p {
        width: 90px;
        height: 30px;
        line-height: 30px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        margin-left: 20px;
      }
    }
  }
  // 搜索
  .screen {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    font-family: PingFangSC-Medium;
    position: relative;
    margin-top: 30px;
    .user-Id {
      margin-left: 30px;
    }
    // 重置搜索按钮样式
    .public-style {
      width: 75px;
      height: 35px;
      text-align: center;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      cursor: pointer;
    }
    // 搜索按钮样式
    .ser-btn {
      background: #409eff ;
      color: #ffffff;
      margin-left: 30px;
      margin-right: 10px;
    }
    // 重置按钮样式
    .heavy-btn {
      background: #ffffff;
      color: #409eff ;
    }
    // 筛选区放input框的div
    .size-search {
      width: 200px;
      height: 30px;
      font-size: 12px;
      /deep/.el-input__inner {
        height: 35px !important;
        font-size: 12px;
        border: 1px solid #409eff ;
      }
    }
  }
  // 内容
  .content-box {
    width: 100%;
    min-height: 320px;
    margin-top: 30px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  //   margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
